import React from 'react';
import { styled } from '@mui/material';

import { Dialog, Icon, IconButton, ProgressBar, Stack, Tag, Text } from 'shell/components';

const SuggestionsModal = ({ visible, groupName, groupStatus, groupProgress, suggestions, onClose }) => {
    return (
        <Dialog open={visible} onClose={onClose}>
            <Stack sx={{ maxWidth: '20rem' }} spacing={4}>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <Stack alignItems={'flex-start'} spacing={2}>
                        <Text variant={'sh1'} weight={'semibold'}>
                            {groupName}
                        </Text>
                        <Tag type={'progress'} value={groupStatus} />
                    </Stack>
                    <IconButton kind={'exit'} size={'medium'} variant={'square'} onClick={onClose} />
                </Stack>
                <Stack spacing={1}>
                    <Stack direction={'row'} justifyContent={'space-between'}>
                        <Text variant={'p2'}>Progress</Text>
                        <Text variant={'p2'}>{groupProgress || 0}%</Text>
                    </Stack>
                    <ProgressBar value={Number(groupProgress)} />
                </Stack>
                <CustomStack spacing={4}>
                    {suggestions.map((suggestion, index) => (
                        <Stack key={index} alignItems={'center'} direction={'row'} spacing={2}>
                            <CustomIcon kind={'error'} size={'xsmall'} variant={'circle'} />
                            <Text variant={'p2'}>{suggestion.text}</Text>
                        </Stack>
                    ))}
                </CustomStack>
            </Stack>
        </Dialog>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        borderRadius: '6px',
        padding: theme.spacing(3),
        background: theme.palette.ensightful.neutral[50],
    };
});

const CustomIcon = styled(Icon)(({ theme }) => {
    return {
        width: '1.5rem',
        height: '1.5rem',
        borderRadius: '50%',
        padding: '0.3125rem',
        background: theme.palette.ensightful.error[700],
        color: theme.palette.ensightful.shades[0],
        '&:hover': {
            background: theme.palette.ensightful.error[700],
        },
    };
});

export default SuggestionsModal;
